import { request } from './service'

/**
 * 登录接口
 * @param {Object} data 登录信息 { username, password }
 */
export function login(data) {
  return request({
    url: 'login/',
    method: 'post',
    data
  })
}

/**
 * 注册接口
 * @param {Object} data 注册信息 { username, password, email, verify_code }
 */
export function register(data) {
  return request({
    url: 'register/',
    method: 'post',
    data
  })
}

/**
 * 登出接口
 */
export function logout() {
  return request({
    url: 'logout/',
    method: 'post'
  })
}

/**
 * 刷新token接口
 * @param {String} refreshToken refresh token
 */
export function refreshToken(refreshToken) {
  return request({
    url: '/token/refresh/',
    method: 'post',
    data: {
      refresh: refreshToken
    }
  })
}

/**
 * 发送验证码
 * @param {Object} data { email }
 */
export function sendVerifyCode(data) {
  return request({
    url: 'send-code/',
    method: 'post',
    data
  })
}

/**
 * 验证验证码
 * @param {Object} data { email, code }
 */
export function verifyCode(data) {
  return request({
    url: 'verify-code/',
    method: 'post',
    data
  })
}

/**
 * 获取用户信息
 */
export function getUserInfo() {
  return request({
    url: 'user/info/',
    method: 'get'
  })
}
